import type { SystemStyleObject } from "@chakra-ui/react"
import { HTMLTextStyles } from "../../text/HTMLText"

/** Scope HTMLText styles to ProseMirror content inside the editor root. */
export const editorContentHTMLTextStyles: SystemStyleObject = Object.entries(
  HTMLTextStyles
).reduce((styles, [selector, value]) => {
  const scopedSelector = selector.replace(/^&(\s*)/, "& .ProseMirror$1")
  return {
    ...styles,
    [scopedSelector]: value
  }
}, {} as SystemStyleObject)
